import React from "react";
import logo from "./images/logo.png";
import { FaWhatsapp } from "react-icons/fa";

function Header({ currentPage, setCurrentPage }) {
  try {
    const [isMenuOpen, setIsMenuOpen] = React.useState(false);

    const navItems = [
      { id: "home", label: "Home" },
      { id: "about", label: "About" },
      { id: "gallery", label: "Gallery" },
      { id: "booking", label: "Booking" },
      { id: "location", label: "Location" },
    ];

    return (
      <header
        className="header-modern fixed top-0 w-full z-50"
        data-name="header"
        data-file="components/Header.js"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            {/* Logo */}
            <div
              className="cursor-pointer"
              onClick={() => setCurrentPage("home")}
            >
              <img
                src={logo}
                alt="Angelo's Farm Logo"
                className="h-10 w-auto object-contain"
              />
            </div>

            {/* Desktop Navigation */}
            <nav className="hidden md:flex space-x-8">
              {navItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => {
                    setCurrentPage(item.id);
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }}
                  className={`nav-link${
                    currentPage === item.id ? " active" : ""
                  } ${
                    currentPage === item.id ? "text-[#B86A4B] !font-bold" : ""
                  }`}
                >
                  {item.label}
                </button>
              ))}
            </nav>

            {/* Book Now Button */}
            <div className="hidden md:flex items-center space-x-4">
              <a
                href="https://wa.me/919256828782" // Replace with your number
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none", color: "green" }}
              >
                <FaWhatsapp size={30} />
              </a>
            </div>

            {/* Mobile Menu Button */}
            <button
              className="md:hidden p-2"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              <div
                className={`icon-${
                  isMenuOpen ? "x" : "menu"
                } text-xl text-stone-700`}
              ></div>
            </button>
          </div>

          {/* Mobile Menu */}
          {isMenuOpen && (
            <div className="md:hidden py-4 border-t border-stone-200">
              <nav className="flex flex-col space-y-2">
                {navItems.map((item) => (
                  <button
                    key={item.id}
                    onClick={() => {
                      setCurrentPage(item.id);
                      setIsMenuOpen(false);
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                    className={`nav-link${
                      currentPage === item.id ? " active" : ""
                    } text-left ${
                      currentPage === item.id ? "text-[#B86A4B] !font-bold" : ""
                    }`}
                  >
                    {item.label}
                  </button>
                ))}
                <a
                  href="https://wa.me/919256828782"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none", color: "green" }}
                >
                  <FaWhatsapp size={30} />
                </a>
              </nav>
            </div>
          )}
        </div>
      </header>
    );
  } catch (error) {
    console.error("Header component error:", error);
    return null;
  }
}

export default Header;
